// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1303":"css/app.7020","8843":"css/admin-app.7020"}[chunkId] + ".css";
};